<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
      <router-link :to="{ name: 'role-links' }" class="root">
        Dashboard
      </router-link>
      <span class="child">/ Subject wise Questions Count</span> </v-row
    ><br />
    <center class="heading">
      <h2>Subject wise Questions Count</h2>
    </center>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col xs="12" sm="12" lg="4" md="6" cols="12">
            <label class="bold">Academic Year</label>
            <v-autocomplete
              :items="ayList"
              item-value="ayid"
              class="select"
              placeholder="Select Academic Year"
              item-text="ay"
              v-model="ay"
              dense
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" lg="4" md="6" cols="12">
            <label class="bold">Semester</label>
            <v-autocomplete
              :items="semList"
              item-value="semid"
              class="select"
              placeholder="Select Semester"
              item-text="sem"
              v-model="sem"
              dense
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" lg="4" md="6" cols="12">
            <label class="bold">Exam</label>
            <v-autocomplete
              :items="examList"
              item-value="examid"
              class="select"
              placeholder="Select Exam"
              item-text="exam"
              v-model="exam"
              dense
              outlined
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-card-actions v-if="sem && ay && exam" class="justify-center">
          <v-btn @click="fetch_Data()" class="mb-2 button btn"
            >Fetch Data</v-btn
          >
        </v-card-actions>
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="cyan"
          height="18"
        >
          <span>Loading...</span>
        </v-progress-linear>
       
        <v-data-table
            :headers="headers"
            class="nowrap" 
            :items="data_list" 
            :search="search"
              v-model="selected"
               @current-items="getFiltered"
                         
            >
            <template v-slot:top>
                <v-toolbar flat color="white">
                 <!-- <download-excel
                    :data="filterArr"
                    :fields="table_fields"
                    worksheet="template_Import"
                    name="template_Import.xls"
                  >
                    <v-btn class="ma-1 white--text" color="green">
                      <v-icon dark>
                        mdi-file-excel-box
                      </v-icon>
                      Export to Excel
                    </v-btn>
                  </download-excel>-->
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                  
                 
                </v-toolbar>
              
              </template>
            <template v-slot:item.template="{ item }">
                  <v-icon color="green" v-if="!item.templateQuestionRequirment"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <v-icon v-else color="red">mdi-close-circle</v-icon>
                </template>
                      <template v-slot:item.verifyQuestions="{ item }" >

                <v-btn dense color="info" :disabled="item.allQuestionsapproved == item.allQuestionsisverified || item.templatename=='No'" small @click="veifyQuestions(item)">Verify Questions</v-btn>
                </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
     search: "",
    loading: false,
    snackbar_msg: "",
    snackbar: false,
    color: "",
    ayList: [],
    semList: [],
    examList: [],
    sem: null,
    ay: null,
    exam: null,
    data_list: [],
     headers: [
      {
        text: "Sr.NO",
        value: "srno",
      },
     
      {
        text: "Course",
        value: "course",
      },
       {
        text: "Template Name",
        value: "templatename",
      },
      {
        text: "Total Question",
        value: "allQuestion",
      },
      {
        text: "Total Approved",
        value: "allQuestionsapproved",
      },
      {
        text: "Total Verified",
        value: "allQuestionsisverified",
      },
      {
        text: "Requirment Questions",
        value: "totalreqQue",
      },
{
        text: "Question Requirment",
        value: "template",
      },
      {
        text: "Verify Questions",
        value: "verifyQuestions",
      },
     
    ],
  }),
  methods: {
    veifyQuestions(item){
      console.log(item)
      this.loading = true;
      const data = {
        courseId:item.courseId,
        exam:this.exam
      }
      axios
        .post("/Examination/verifyQuestions", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.showSnackbar("#4CAF50", "Question verified Successfully.");
            this.fetch_Data();
            this.loading = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    fetch_Data() {
      this.loading = true;
      const data = {
        ay: this.ay,
        sem: this.sem,
        exam: this.exam,
      };
      axios
        .post("/Examination/getQuestionDetails", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.data_list = res.data.detailsList;
            this.loading = false;
          } else {
            this.showSnackbar("#b71c1c", "Data not available!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },

  mounted() {
    axios
      .post("/Examination/getAySemExamList")
      .then((res) => {
        window.console.log(res);
        if (res.data.msg == "200") {
          this.ayList = res.data.ayList;
          this.semList = res.data.semList;
          this.examList = res.data.examList;
        } else {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        }
      })
      .catch((error) => {
        window.console.log("error:" + error);
      });
  },
};
</script>
<style scoped></style>
